/**
 * 404 (Reppr Elite, phase 7). The mock's "everything in Reppr is versioned
 * and recoverable" line is a claim the product doesn't make — not shipped.
 */

import { Link } from 'react-router-dom'
import PublicShell from '../components/public/PublicShell'
import { getSupportMailto } from '../lib/config'
import shell from '../components/public/PublicShell.module.css'
import styles from './NotFound.module.css'

export default function NotFound() {
  return (
    <PublicShell>
      <div className={styles.wrap}>
        <span className={styles.code}>ERROR 404</span>
        <h1 className={styles.title}>This page is not on the books.</h1>
        <p className={styles.body}>
          The link may be old, or the page may have been moved. Nothing you
          were working on is affected.
        </p>
        <div className={styles.ctas}>
          <Link to="/" className={shell.btnPrimary}>Back to home</Link>
          <a href={getSupportMailto('Broken link')} className={shell.btnGhost}>
            Contact support
          </a>
        </div>
      </div>
    </PublicShell>
  )
}
